import {
  QuoteItemPostRequestBody,
  QuoteItemPostRequestParams,
  QuoteItemPostResponse,
  QuoteItemsSearchResponse,
} from '@lio/api-types';
import { quoteItemQueryKey } from '@services/quoteItem/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateQuoteItem = () => {
  const client = useClient();
  const queryClient = useQueryClient();
  const mutationFn = ({
    quoteId,
    quoteItemAttributes,
    quoteItemTypeId,
    instanceNumber,
    parentId,
  }: QuoteItemPostRequestBody & QuoteItemPostRequestParams & { invalidateQuoteQuery?: boolean }) =>
    client
      .post(`quote/${quoteId}/quote-item`, {
        json: {
          quoteItemAttributes,
          quoteItemTypeId,
          instanceNumber,
          parentId,
        },
      })
      .json<QuoteItemPostResponse>();
  const result = useMutation({
    mutationFn,
    onError: () => {
      return false;
    },
    onSuccess: (data, variables) => {
      const quoteQueryKey = quoteItemQueryKey.searchWithParams({
        quoteId: variables.quoteId,
      });

      queryClient.invalidateQueries({
        queryKey: ['quote', { quoteId: variables.quoteId }],
      });

      if (variables.invalidateQuoteQuery && data.instanceNumber) {
        // if invalidateQuoteQuery is true we know the api is going to update underlying quote items and we need to refetch the quote items
        queryClient.invalidateQueries({ queryKey: quoteQueryKey });
      } else {
        queryClient.setQueryData<QuoteItemsSearchResponse>(quoteQueryKey, (previousQuoteItemSearch) => ({
          ...previousQuoteItemSearch,
          items: (previousQuoteItemSearch?.items ?? []).concat([{ ...data, quoteItemCoverages: [] }]),
        }));
      }
    },
  });
  return { ...result, createQuoteItem: result.mutate, createQuoteItemAsync: result.mutateAsync };
};
